import styled from '@emotion/styled';

export type GlassPillSize = 'small' | 'medium' | 'large';

/** `small` is the detail pane's back button, tucked in the hero corner. */
const FONT_PX: Record<GlassPillSize, number> = { small: 18, medium: 22, large: 26 };
const PADDING: Record<GlassPillSize, string> = {
  small: '10px 20px',
  medium: '16px 28px',
  large: '22px 34px',
};
const GAP_PX: Record<GlassPillSize, number> = { small: 8, medium: 12, large: 14 };

/**
 * The frosted "glass" pill used over photos: translucent dark fill, hairline
 * border, blur. Shared by the button and the static tag so they always match.
 */
export const GlassPillBase = styled.button<{ size?: GlassPillSize }>`
  appearance: none;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  color: var(--colorWhite);
  font-family: var(--eposFontFamily);
  font-weight: 700;
  letter-spacing: -0.2px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.15s ease-out;

  font-size: ${({ size = 'medium' }) => FONT_PX[size]}px;
  padding: ${({ size = 'medium' }) => PADDING[size]};
  gap: ${({ size = 'medium' }) => GAP_PX[size]}px;

  &.is-touching {
    transform: scale(0.95);
  }
`;

/** Icon size that matches each pill size. */
export const GLASS_PILL_ICON_SIZE: Record<GlassPillSize, string> = {
  small: '20px',
  medium: '26px',
  large: '28px',
};
